import React from 'react';

import Button from '@pb/kit-component-button';
import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';

import {AddSectionModal} from './add-section.modal';

type Props = {
    onAdd: () => void,
    sectionsCount: number,
    conferenceId: number,
};

export const AddSection = ({onAdd, sectionsCount, conferenceId}: Props) => {
    const {shown, onClick, onClose} = useShown();

    return (
        <>
            <Button variant="Type.SECONDARY" onClick={onClick}>
                Add Section
            </Button>
            <Dialog shown={shown} setShown={onClose} wrapperProps={{style: {width: 600}}}>
                <AddSectionModal
                    conferenceId={conferenceId}
                    onClose={onClose}
                    onAdd={onAdd}
                    sectionsCount={sectionsCount}
                />
            </Dialog>
        </>
    );
};
